<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4">
    <h3>Meldinger</h3>
    <br/>
    <span>Her kan du legge til meldinger/informasjon som vises til gjester på forsiden i nettbutikken.</span>
    <br/>
    <div class="bo_responsive-users-table-header">
          <span class="right-align">
              <button type="button" class="bo_btn" @click="goToCreatePage"> + Legg til melding </button>
          </span>
    </div>

    <div class="table-responsive-sm mt-3">
        <table class="table table-striped">
        <thead>
          <tr>
              <th></th>
              <th v-if="hasMultiLocations()">Avdeling</th>
              <th>Vis fra og med</th>
              <th>Vis til og med</th>
              <th>Melding</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="announcement in announcements" :key="announcement.id">
              <td>
                <a class="remove-user-btn"
                   @click="removeAnnouncement(announcement)">
                  <img src="@/assets/images/remove.png" width="21" title="Slett"/>
                </a>
              </td>
              <td v-if="hasMultiLocations()">
                <span>{{ getLocationName(announcement.locationId) }}</span>
              </td>
              <td>
                {{ getDateText(announcement.displayFromDate) }}
              </td>
              <td>
                {{ getDateText(announcement.displayToDate) }}
              </td>
              <td>
                {{ announcement.message }}
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ConfirmDialogue ref="confirmDialogue"></ConfirmDialogue>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SettingsService from "@/services/settings/SettingsService";
  import ConfirmDialogue from "@/components/other/ConfirmDialogue";
  import moment from "moment";
  import LocationUtil from "@/util/LocationUtil";

  export default {
    components: {LoadingSpinner, ConfirmDialogue},
    data() {
      return {
        loading: true,
        announcements: []
      };
    },
    mounted() {
      this.getAnnouncements();
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      getLocationName(locationId){
        let location = LocationUtil.getLocation(locationId);
        return location.name;
      },
      goToCreatePage(){
        this.$router.push({ path: 'announcementCreate'});
      },
      getAnnouncements(){
        SettingsService.getAnnouncements().then(
            (response) => {
              this.announcements = response.data;
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      getDateText(date){
        var dateMoment = moment(date);
        return dateMoment.format('DD.MM.YYYY');
      },
      async removeAnnouncement(announcement){
        const ok = await this.$refs.confirmDialogue.show({
          title: 'Slett melding',
          message: 'Vil du slette meldingen "' + announcement.message + '"?',
          okButton: 'Slett',
          cancelButton: 'Avbryt'
        })
        if(ok) {
          SettingsService.deleteAnnouncement(announcement).then(
              (response) => {
                if(response.data === 'SUCCEEDED'){
                  this.$router.go(); //Reload current page
                }else {
                  console.log("Deleting announcement failed");
                }
              },
              (error) => {
                console.log(error);
              }
          );
        } else {
          //Cancel, do nothing
        }
      }
    }
  };
</script>
